import type { CampaignSimpleResponse } from '@coorum-research/shared-common/api-response/popup.schema'
import type { ThemeConfig } from '@coorum-research/shared-common/types/theme.type'
import { CampaignSelectionComponent } from '@coorum-research/core/src/components/CampaignSelectionComponent'
import { useQuery } from '@tanstack/react-query'
import { campaignSelectionSettingsApi } from '../apis/campaign-selection-settings.api'

type Props = {
  campaignSelectionContentId?: string | null
  theme?: ThemeConfig
  campaigns: CampaignSimpleResponse[]
  onSelected: (campaignId: string, campaignName: string) => void
}

export function CampaignSelectionApp({ campaignSelectionContentId, theme, campaigns, onSelected }: Props) {
  const { getCampaignSelectionSetting } = campaignSelectionSettingsApi()

  const { data: launcherContent } = useQuery({
    queryKey: ['get-campaign-selection-setting', campaignSelectionContentId],
    queryFn: () => {
      if (!campaignSelectionContentId) {
        return
      }
      return getCampaignSelectionSetting(campaignSelectionContentId)
    },
    enabled: !!campaignSelectionContentId,
  })

  return (
    <>
      <CampaignSelectionComponent
        theme={theme}
        contentConfig={launcherContent?.configJson ?? undefined}
        campaigns={campaigns}
        onSelected={onSelected}
      />
    </>
  )
}
